// @flow
import SVGIcon from '~/core/icons/svg-icons';
import styled from 'styled-components';

export const BoostContainer = styled.div`transition: height 0.5s linear;`;

export const BoostHeader = styled.div`
    cursor: pointer;
    display: flex;
    justify-content: center;
    height: 2rem;
    margin-top: 3rem;
`;

export const BoostTimer = styled.h3`
    width: 15%;
    float: left;
    text-align: right;
    margin: 0;
`;

const iconSize = '1em';
export const DropdownIcon = styled(SVGIcon)`
    cursor: pointer;
    height: ${iconSize};
    margin-left: 0.2em;
    position: relative;
    top: 0.2em;
    width: ${iconSize};
`;



// WEBPACK FOOTER //
// ./src/components/widgets/boost/styles.js